import api from '~/services/api'
import { IBrowserId } from './../model/types'
export const saveIdBrowser = async (id: number, browserInfo: IBrowserId[], sessionId: number, shopId: number, clientID: string) => {
  await api.post(`/guest/${id}/browser-id`, {
    browser_info: browserInfo,
    session_id: sessionId,
    shop_id: shopId,
    client_info: [
      {
        client_id: clientID,
        plugin: 'yandex_metrika'
      }
    ]
  })
}
